import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Page service is here to retrieve all single page data objects.
*/
const DEFAULT_HEADER:string = "/assets/images/hero/bg-books.jpg"

@Injectable({
  providedIn: 'root'
})
export class PageService {

  currentHeader:string = DEFAULT_HEADER;

  constructor(private http:HttpClient) { }

  getHome() {
    return this.http.get<any>(`${environment.apiBaseUrl}/home`);
  }

  getPage(page:string) {
    return this.http.get<any>(`${environment.apiBaseUrl}/${page}?populate=*`);
  }

  /* Header ops */
  resetCurrentHeader() {
    this.currentHeader = DEFAULT_HEADER;
  }

  setCurrentHeader(header:string) {
    if(header != null && header != "") {
      this.currentHeader = header;
    }
  }

  getCurrentHeader() {
    return this.currentHeader;
  }
}
